<template>
  <div class="form-group">
    <validation-item
      :label="label"
      :name="validationFieldName"
      :rules="rules"
      :vid="vid"
    >
      <template>
        <vue-dropzone
          v-if="dropzoneOptions.url"
          @vdropzone-removed-file="removeFile"
          @vdropzone-success="uploadSuccess"
          @vdropzone-file-added="fileAdded"
          id="dropzone"
          ref="myVueDropzone"
          :use-custom-slot="true"
          :options="dropzoneOptions"
        >
          <div class="dropzone-custom-content">
            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
            <h6>{{ placeholder }}</h6>
          </div>
        </vue-dropzone>
        <input hidden :value="value" />
      </template>
    </validation-item>
  </div>
</template>

<script>
import ValidationItem from './ValidationItem'
import vue2Dropzone from 'vue2-dropzone'

export default {
  name: 'ValidationFileUpload',
  components: { ValidationItem, vueDropzone: vue2Dropzone },
  props: {
    label: {
      type: String,
      default: '',
    },
    validationFieldName: {
      type: String,
      default: '',
    },
    rules: {
      type: [String, Object, Array],
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'فایل را به اینجا بکشید یا اینجا را کلیک کنید',
    },
    value: {
      type: [Array, String],
      default: '',
    },
    options: {
      type: Object,
      default: undefined,
    },
    acceptedFiles: {
      type: String,
      default: 'image/*',
    },
    fileType: {
      type: String,
      default: 'image',
    },
  },
  data() {
    return {
      dropzoneOptions: {
        maxFilesize: 1,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: this.acceptedFiles,
        dictRemoveFile: 'حذف',
        dictFileTooBig:
          'سایز فایل شما نباید بیشتر از {{maxFilesize}} مگابایت باشد',
        dictCancelUpload: 'لغو آپلود',
        dictUploadCanceled: 'آپلود کنسل شد',
        dictMaxFilesExceeded: 'شما نمی توانید فایل های بیشتری را انتخاب کنید',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      },
      files: this.value,
      isExistingFileAdded: false,
      cropperImageSrc: '',
    }
  },
  computed: {
    isMultiple() {
      return this.dropzoneOptions.maxFiles > 1
    },
  },
  watch: {
    value(newValue) {
      this.files = newValue
    },
  },
  mounted() {
    if (this.options !== undefined) {
      this.dropzoneOptions = { ...this.dropzoneOptions, ...this.options }
    }
    if (this.options !== undefined && !this.options.url) {
      switch (this.fileType) {
        case 'image':
          this.dropzoneOptions.url =
            process.env.VUE_APP_API_URL + '/upload-image'
          break
        case 'video':
          this.dropzoneOptions.url =
            process.env.VUE_APP_API_URL + '/upload-video'
          break
        case 'file':
          this.dropzoneOptions.url =
            process.env.VUE_APP_API_URL + '/upload-file'
      }
    } else {
      this.dropzoneOptions.url = process.env.VUE_APP_API_URL + this.options.url
    }
    this.$nextTick(function() {
      if (!this.isExistingFileAdded) this.addManuallyFiles()
    })
  },
  methods: {
    uploadSuccess(file, response) {
      this.isExistingFileAdded = true
      if (this.isMultiple) {
        this.files.push(response.default)
      } else {
        this.files = response.default
      }
      this.$emit('input', this.files)
    },
    removeFile(file) {
      if (this.isMultiple) {
        this.files.splice(this.files.indexOf(file), 1)
      } else {
        if (this.files === file) this.files = ''
      }
      this.$emit('input', this.files)
    },
    addManuallyFiles() {
      if (this.isMultiple) {
        if (this.files.length > 0) {
          this.isExistingFileAdded = true
          this.files.forEach((item) => {
            if (this.fileType === 'image') {
              const file = { size: '', name: 'Icon', type: 'image/png' }
              this.$refs.myVueDropzone.manuallyAddFile(file, item)
            }
          })
        }
      } else {
        if (this.files !== '') {
          if (this.fileType === 'image') {
            this.isExistingFileAdded = true
            const file = { size: '', name: 'Icon', type: 'image/png' }
            this.$refs.myVueDropzone.manuallyAddFile(file, this.files)
          }
        }
      }
    },
    fileAdded(file) {
      if (this.fileType === 'image') {
        this.cropperImageSrc = URL.createObjectURL(file)
      }
    },
  },
}
</script>

<style>
.vue-dropzone > .dz-preview .dz-remove {
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  color: red;
  border: 1px solid transparent;
  margin-left: 0;
  padding: 5px;
}
</style>
